import { SS } from 'ls-ts';

export interface TempPromoStore {
  startDate?: string;
  customOrderParameters?: { [key: string]: string };
  customSubscriptionParameters?: { [key: string]: string };
}

const SS_PROMO_KEY = 'promo_NonSubscribedRedeem';

const store = (value: TempPromoStore) => SS.write(SS_PROMO_KEY, value);

const read = (): TempPromoStore => SS.read<TempPromoStore>(SS_PROMO_KEY, {});

const remove = () => SS.remove(SS_PROMO_KEY);

/**
 * Temporary promo store is a temporary solution for pesisting some additional data
 * that needs to be passed to the purchase step. It uses Session Storage. Normally Payment Context
 * would be used to store this data, but it felt it would clutter the context too much.
 * Good thing about it is that this way we can quite dynamically adjust the data here without worrying about unexpected impact on other parts of the payment process.
 * Unfortunately I expect we may change things here when UAT testing starts.
 */
const ssActions = { read, remove, store };

export default ssActions;
